import { Box, Grid, Typography, Paper } from "@mui/material";
// import { useColorScheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import limcatLogo from "../assets/partners/limcat.png";
import berrysLogo from "../assets/partners/berrys.png";
import czcLogo from "../assets/partners/czc.png";
// import ghostOpticsLightLogo from "../assets/partners/ghost-optics-light.png";
// import ghostOpticsDarkLogo from "../assets/partners/ghost-optics-dark.png";

export default function Partners() {
  // const { mode, systemMode } = useColorScheme();
  const partners = [
    // PNG/JPG logos work best with light backgrounds
    { name: "Limcat", logo: limcatLogo, link: "https://www.limcat.com/" },
    { name: "Berry's", logo: berrysLogo, link: "https://www.berrysmfg.com/" },
    { name: "CZ Custom", logo: czcLogo, link: "https://czcustom.com/" },
    // {
    //   name: "Ghost Optics",
    //   logo:
    //     (mode === "system" && systemMode === "light") || mode === "light"
    //       ? ghostOpticsLightLogo
    //       : ghostOpticsDarkLogo,
    //   link: "https://ghost-optics.com/",
    // },
  ];

  const { t } = useTranslation();
  return (
    <Box
      id="partners"
      sx={{
        pt: { xs: 4, md: 6 },
        px: { xs: 2, md: 0 },
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: { xs: "100%", lg: "60%" },
          px: { xs: 3, md: 6 },
          py: { xs: 2, md: 4 },
          borderRadius: 3,
          textAlign: "center",
        }}
      >
        <Typography variant="h4" component="h2" gutterBottom>
          {t("home.partnersTitle")}
        </Typography>
        <Typography
          variant="overline"
          color="text.secondary"
          sx={{ letterSpacing: 1 }}
        >
          {t("home.partnersCaption")}
        </Typography>

        <Grid
          container
          spacing={{ xs: 3, md: 6 }}
          alignItems="center"
          justifyContent="center"
          sx={{ mt: 2 }}
        >
          {partners.map((partner) => (
            <Grid
              size={{ xs: 6, sm: 4, md: 3 }}
              key={partner.name}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box
                component="a"
                href={partner.link}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: "inline-flex" }}
              >
                <Box
                  component="img"
                  src={partner.logo}
                  alt={partner.name}
                  sx={{
                    maxWidth: { xs: "90%", sm: "80%" },
                    maxHeight: 120,
                    opacity: 0.7,
                    filter: "grayscale(100%) brightness(0.9)",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      opacity: 1,
                      filter: "grayscale(0%) brightness(1)",
                    },
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Box>
  );
}
